import type { ImageType, VideoType } from '@/types/generics'
import type { CardCarousel } from '@/types/sanity'

export const isCardCarousel = (cardCarousel: CardCarousel | undefined) => {
  return (
    !!cardCarousel &&
    cardCarousel?.disableCarousel !== true &&
    cardCarousel?.items?.length > 1
  )
}

export const mapCardCarouselItems = (
  cardCarousel: CardCarousel,
  {
    heading,
    firstItem,
  }: { heading: string; firstItem: ImageType | VideoType | null },
) => {
  return [
    firstItem,
    ...(cardCarousel?.items.map((item) => {
      return {
        url: item?.url,
        alt: item?.alt || heading || '',
        type: item?.format === 'mp4' ? 'video' : 'image',
      }
    }) || []),
  ]
}
